import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

import ManagerialDashboard from "@/components/screens/ManagerialDashboard";
import SalesDashboard from "@/components/screens/SalesDashboard";
import ServiceDashboard from "@/components/screens/ServiceDashboard";
import {
  SALES_DASHBOARD_MESSAGES,
  type SalesDashboardMessages,
} from "@/messages/salesDashboard/sales-dashboard.messages";
import {
  SERVICE_DASHBOARD_MESSAGES,
  type ServiceDashboardMessages,
} from "@/messages/serviceDashboard/service-dashboard.messages";
import translationService from "@/services/translation.service";
import { type Language, type Translation } from "@/types/language.types";

const ServiceDashboardRedirect = () => {
  const { lang = "PT-BR" } = useParams();
  return <Navigate to={`/dashboard/service/operational/${lang}`} replace />;
};

const Dashboard: React.FC = () => {
  const { lang = "PT-BR" } = useParams();
  const [salesMessages, setSalesMessages] = useState<Translation<SalesDashboardMessages> | null>(
    null
  );
  const [serviceMessages, setServiceMessages] =
    useState<Translation<ServiceDashboardMessages> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const [salesTranslations, serviceTranslations] = await Promise.all([
          translationService.get<SalesDashboardMessages>(
            SALES_DASHBOARD_MESSAGES,
            (lang as Language) ?? null
          ),
          translationService.get<ServiceDashboardMessages>(
            SERVICE_DASHBOARD_MESSAGES,
            (lang as Language) ?? null
          ),
        ]);
        setSalesMessages(salesTranslations);
        setServiceMessages(serviceTranslations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!salesMessages || !serviceMessages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return (
    <Routes>
      <Route path="/sales/:lang" element={<SalesDashboard messages={salesMessages} />} />
      <Route
        path="/service/operational/:lang"
        element={<ServiceDashboard messages={serviceMessages} />}
      />
      <Route
        path="/service/managerial/:lang"
        element={<ManagerialDashboard messages={serviceMessages} />}
      />
      <Route path="/service/:lang" element={<ServiceDashboardRedirect />} />
      <Route path="/sales" element={<SalesDashboard messages={salesMessages} />} />
      <Route path="/service" element={<ServiceDashboardRedirect />} />
      <Route path="/" element={<SalesDashboard messages={salesMessages} />} />
    </Routes>
  );
};

export default Dashboard;
